import React, { Component } from 'react';
import {  Container , Row , Col  } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';

import {GET_JOB_HOME} from '../jobs/apis';
import CardJob from '../jobs/job-card.component';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {Paper ,Button, Card } from '@material-ui/core';
import noPostsFound from '../../homepage/images/no-posts.svg';
import {Skeleton} from "@material-ui/lab"


export default function  YourJobs(){
    const { loading, error, data , refetch} = useQuery(GET_JOB_HOME);

    const callBack = (data) => {
        if (data === "update") {
            refetch();
        }
    }
    if (error) return `Error! ${error.message}`;
    if(loading) {
        return (
        <div>
                <Container className="mt-5">
                    <Row className="justify-content-center align-items-center">
                        <Col md={2} xs={12} className="">
                            <Skeleton variant="rect" height={150} />
                        </Col>
                        <Col md={10}>
                            <Skeleton variant="text" width={150} />
                            <Skeleton variant="text" width={130} />
                            <Skeleton variant="text" width={250} />
                        </Col>
                    </Row>
                    <Row className="justify-content-center align-items-center mt-3">
                        <Col md={2} xs={12} className="">
                            <Skeleton variant="rect" height={150} />
                        </Col>
                        <Col md={10}>
                            <Skeleton variant="text" width={150} />
                            <Skeleton variant="text" width={130} />
                            <Skeleton variant="text" width={250} />
                        </Col>
                    </Row>
                </Container>
        </div>)
    }
    else{
        let jobs = data.me.companyAuth.jobsGet?.data.filter(job=>job.job_status.id == 1);
        console.log(data)
        console.log(jobs);
        if(!jobs){
            return(
                <Container className="pt-5">
                    <Paper elevation={3}>
                        <Row elevation={3} className="bg-light m-0 p-3" style={{borderBottom:'1px solid #f2f2f2'}}>
                                <Col xs={6}>
                                    <h5>Live Jobs</h5>
                                </Col>
                                <Col md='12'  className="text-center pt-2 pb-5">
                            <div className="pt-3 pb-3">
                                <img src={noPostsFound} alt="No Posts" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="text-grey">You've no Jobs yet</p>
                            </div>
                            <div>
                                <Link 
                                    onClick={e=>{
                                        window.scrollTo({ top: 0, behavior: 'smooth' })
                                        localStorage.setItem('updatedJobPost','')
                                        }} to="/createJob">
                                    <Button  size="large" varient="outlined" className="btn-orange-gradiant text-white pr-5 pl-5">Post Job</Button>
                                </Link>
                            </div>
                        </Col>
                        </Row>
                    </Paper>
                </Container>
            )
        }
        else{
            return(<div>
            <Container className="pt-5">
                <Paper elevation={3}>
                    <Row elevation={3} className="bg-light m-0 p-3" style={{borderBottom:'1px solid #f2f2f2'}}>
                            <Col xs={6}>
                                <h5>Live Jobs</h5>
                            </Col>
                             <Col className="text-right" xs={6}>
                                <h5><Link className="text-orange" to='/jobs '>See All <ArrowForwardIcon /></Link></h5>
                            </Col>
                    </Row>
                    <Row className="m-0">
                        <Col md='12' className="pt-3 pb-3" style={{borderBottom:'1px solid #f2f2f2'}}>
                        {
                                <CardJob type="liveJobs"  data={jobs} callBack={callBack} />
                        }
                        </Col>
                     </Row>
                </Paper>
            </Container>
        </div>);
        }  
    } 
}